import React from 'react';
import LocationMap from "./LocationMap";
import { CalendarModal } from "./CalendarModal";
import {useDisclosure} from "./useDisclosure";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";
import {useRsvp} from "../context/RsvpContext";

const NightSkyCalendar: React.FC = () => {
    const {rsvp} = useRsvp();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate("/info", { replace: true, state: { lodging: true } });
    };

    return (
        <div className="container mx-auto px-4 relative z-10 mt-20">
            <div className="grid md:grid-cols-2 gap-16 items-top">

                <div className="text-center">
                    <div
                        className="rounded-lg">
                        <div className="bg-[rgb(var(--calendar-color))]/40 rounded-[70px] p-6 shadow-xl">
                            <div className="text-center">
                                <div className="text-2xl text-white mb-4" style={{fontWeight: 50, fontSize: '25px'}}>Marzo 2026</div>
                                <div className="grid grid-cols-7 gap-1 text-sm text-white mb-2">
                                    {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
                                        <div key={day + index} className="p-2 font-semibold">{day}</div>
                                    ))}
                                </div>
                                <div className="grid grid-cols-7 gap-1 text-sm text-white">
                                    {Array.from({length: 31}, (_, i) => i + 1).map(day => (
                                        <div key={day}
                                             className={`p-2 text-white 
                                             ${(day >= 20 && day <= 22) ? 'bg-(--hover-color) rounded-full font-bold' : ''}
                                             `}
                                             style= {(day >= 20 && day <= 22) ? {fontWeight: 800, fontSize: '15px'} : {fontWeight: 50, fontSize: '15px'}}
                                        >
                                            {day}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <CustomButton
                                onClick={onOpen}
                                text={'Agregar a mi calendario'}
                                bgColor={'bg-[#5a7ca0]'}
                                hoverColor={'hover:bg-(--hover-color)'}
                            />
                        </div>
                    </div>
                </div>
                <LocationMap/>
            </div>

            {!rsvp?.invitado_especial && (<div className="flex justify-center-safe mt-10">
                <CustomButton text="Ver opciones de hospedaje" bgColor={'bg-[#5a7ca0]'}
                              hoverColor={'hover:bg-(--hover-color)'}
                              onClick={handleNavigate}
                />
            </div>)}
            <CalendarModal isOpen={isOpen} onClose={onClose} />
        </div>
    );
};

export default NightSkyCalendar;
